import { Checkbox, Descriptions, List, Radio, type CheckboxChangeEvent } from "antd";
import InputWithTags from "./InputWithTags";
import "./styles/selectedFilters.css";
import type { ListType } from "../../../../shared/api/ApiType";
import type { SelectedFiltersType } from "./types/SelectedFiltersType";

const SelectedFilters: React.FC<SelectedFiltersType> = ({
    appliedFilters,
    allCurrentOpenedFilters,
    ignoredFilter,
    setIgnoredFilter,
    updateFilter
}) => {

    const handleChange = (e: CheckboxChangeEvent, key: ListType["key"]) => {
        setIgnoredFilter(prev => ({ ...prev, [key]: e.target.checked }));
    }

    return (
        <List
            className="list"
            dataSource={allCurrentOpenedFilters}
            style={{ width: "auto" }}
            renderItem={curFilter => {
                const filtrValues = appliedFilters.find(f => f.key === curFilter.key);
                return (
                    <Descriptions
                        bordered
                        column={2}
                        size="small"
                        className="adaptive-descriptions"
                    >
                        <Descriptions.Item
                            className="table-value"
                            style={{ border: "none", backgroundColor: 'white' }}
                            label={curFilter.label}
                        >
                            <InputWithTags
                                curFilter={curFilter}
                                disabled={curFilter.key !== "" && !(ignoredFilter[curFilter.key] ?? true)}
                                appliedFilters={appliedFilters}
                                updateFilter={updateFilter}
                            />
                        </Descriptions.Item>

                        <Descriptions.Item
                            className="table-value"
                            style={{ border: "none", backgroundColor: 'white' }}
                            styles={{ label: { paddingRight: 0 }, content: { paddingLeft: 0 } }}
                            label={
                                <Radio.Group
                                    value={filtrValues?.filtration_type || curFilter?.defaultFilterType}
                                    onChange={(e) => {
                                        updateFilter(curFilter.key, filtrValues?.values || [], e.target.value);
                                    }}
                                    options={
                                        curFilter.filterCategory === "equal" && [
                                            { value: "equal", label: "equal" }
                                        ] ||
                                        curFilter.filterCategory === "all" && [
                                            { value: "equal", label: "equal" },
                                            { value: "include", label: "include" },
                                            { value: "exclude", label: "exclude" },
                                        ]}
                                    disabled={curFilter.key !== "" && (!(ignoredFilter[curFilter.key] ?? true) || !filtrValues?.values.length)}
                                />
                            }>
                            <Checkbox
                                checked={ignoredFilter[curFilter.key] ?? true}
                                onChange={(e) => handleChange(e, curFilter.key)}
                            />
                        </Descriptions.Item>
                    </Descriptions>
                )
            }}
        />
    )

}

export default SelectedFilters;